var image_viewer_rtlignore_default = {
  "fontElementMap": "RvoKL",
  "imageContainer": "h7hbg",
  "expandButton": "uVSz1",
  "expandIcon": "VpaD4",
  "pointer": "M0Zq8",
  "imageWrapper": "_5AgSN",
  "imageRatio": "QAJxo",
  "image": "E4lBC",
  "imageOverlay": "We8VK",
  "imagePreload": "ho7WB",
  "imageHighres": "bQWBt",
  "onlyHighRes": "FjFi5",
  "image_loading": "-XSTP"
};
export {
  image_viewer_rtlignore_default as default
};
//# sourceMappingURL=image-viewer.rtlignore-scss.js.map
